import { Form, Input } from 'antd';
import { useFetchServicePreferences } from '@/hooksApi';

/**
 * Keeps the per-order `serviceCode` field registered on the order form.
 *
 * SVC-STEP — the merchant picks the service in its own wizard step, with the
 * delivery window, success rate and returns time next to a real price per
 * service. A dropdown here as well would be two controls for one decision.
 * Every merchant gets that step in place of a carrier step (owner 2026-10-28:
 * no carrier on any merchant screen).
 *
 * BOXY-501 — but the FIELD must stay registered: "Use Boxy Select" on a
 * multi-box refusal sets `serviceCode`, and an unmounted field is dropped by
 * getFieldsValue(), so the payload would never carry the switch. Nothing is
 * pre-selected, so the merchant's standing rules still apply.
 *
 * Renders nothing when there is at most one live service — there is nothing to
 * choose.
 */
const ServiceLevelCard = () => {
  const { data } = useFetchServicePreferences();

  const services = data?.services ?? [];
  if (services.length < 2) return null;

  return (
    <Form.Item name='serviceCode' hidden noStyle>
      <Input />
    </Form.Item>
  );
};

export default ServiceLevelCard;
